import type { WorkspaceCurrentRoutesResponse } from "@storyboard/web-client";
import { idx, store } from "@/store/store";
import type { CurrentRouteRow } from "@/store/types";

/**
 * Lands one page of a current-routes walk in the store for the workspace it was read for.
 *
 * Replaces the drivers the page names and drops those in `removedMembershipIds`, after the upserts, so a driver named
 * in both ends up removed. Other workspaces' rows are never touched.
 */
export async function applyCurrentRoutesPage(workspaceId: string, page: WorkspaceCurrentRoutesResponse): Promise<void> {
  const rows: CurrentRouteRow[] = page.drivers.map((driver) => ({ ...driver, workspaceId }));
  store.batch(() => {
    store.upsert("currentRoute", rows);
    // Removals land last, so a driver the page both returned and removed is gone.
    store.delete("currentRoute", page.removedMembershipIds);
  });
}

/**
 * Drops every held driver of the workspace not in `named`, once a full walk has named the whole fleet.
 *
 * Other workspaces' rows are never touched.
 */
export async function sweepCurrentRoutes(workspaceId: string, named: ReadonlySet<string>): Promise<void> {
  const departed = [...idx.currentRoutesByWorkspace.keys(workspaceId)].filter((key) => !named.has(key));
  store.delete("currentRoute", departed);
}
